import { Media } from "./Media";
import { Post } from "./Post";
import { VideoScript } from "./VideoScript";
import { Coach, Player } from "./UserAccount";

export namespace VideoProject {
  export namespace Preferences {
    export enum Tone {
      FUN = "FUN",
      PROFESSIONAL = "PROFESSIONAL",
      SERIOUS = "SERIOUS",
    }

    export enum MusicGenre {
      JAZZ = "JAZZ",
      CHILL = "CHILL",
      ROCK = "ROCK",
      LOFI = "LOFI",
      LOUNGE = "LOUNGE",
      HIPHOP = "HIPHOP",
      LATIN = "LATIN",
    }
  }

  export interface Preferences {
    id: number;
    videoProjectId: number;
    captions: boolean;
    emojis: boolean;
    bRoll: boolean;
    music: boolean;
    captionColors?: string | null;
    tone?: Preferences.Tone | null;
    musicGenre?: Preferences.MusicGenre | null;
  }

  export type ExtraFields = {
    preferences?: Preferences;
    player?: Player;
    coach?: Coach;
    originalProject?: VideoProject;
    post?: Post;
    videoScript?: VideoScript;
    originalMedia?: Media[];
    editedMedia?: Media[];
  };

  export enum Status {
    SUBMITTED_FOR_EDITING = "SUBMITTED_FOR_EDITING",
    READY_TO_POST = "READY_TO_POST",
    SCHEDULED = "SCHEDULED",
    POSTED = "POSTED",
    POST_FAILED = "POST_FAILED",
  }

  export enum Source {
    PLAYER_WEB = "PLAYER_WEB",
    COACH_WEB = "COACH_WEB",
    PLAYER_MOBILE = "PLAYER_MOBILE",
  }
}

export interface VideoProject extends VideoProject.ExtraFields {
  id: number;
  playerId: number;
  coachId: number;
  originalProjectId?: number | null;
  postId?: number | null;
  videoScriptId?: number | null;
  status: VideoProject.Status;
  source?: VideoProject.Source | null;
  statusLabel?: string;
  statusDate?: string | null;
  preferredPostDate?: string | null;
  isTestProject?: boolean;
  editedBy?: string | null;
  editedDate?: string | null;
  autoCaption?: boolean;
  createdDate?: string;
  updatedDate?: string;
}
